export type QuestionType =
  | "category_assignment"
  | "linear_scale"
  | "multi_select_matrix"
  | "multiple_choice"
  | "nps"
  | "open_ended"
  | "pricing"
  | "ranking"
  | "rating_scale"
  | "single_choice"
  | "single_select_matrix";

/**
 * Comparison a skip-logic rule applies between an answer and its
 * `option_index`, mirroring the backend `RuleOperator` enum
 * (`fluentive/metadata/_rule.py`). Values are the wire-format strings sent
 * over the API. `Equal` / `NotEqual` compare a single selected option
 * (single choice, category assignment); `In` / `NotIn` test membership in a
 * multiple-choice selection.
 */
export enum RuleOperator {
  Equal = "eq",
  NotEqual = "neq",
  In = "in",
  NotIn = "notin",
}
